import { MEMBER_ROUTES } from "./routes";

export const tabOptions = [
  { label: "Circuits", value: MEMBER_ROUTES["circuits"] },
  { label: "Protocols", value: MEMBER_ROUTES["protocols"] },
  { label: "Workout Plans", value: MEMBER_ROUTES["workout-plans"] },
];
